import { render, staticRenderFns } from "./ElAktasBusena.vue?vue&type=template&id=94f02924&"
import script from "./ElAktasBusena.vue?vue&type=script&lang=js&"
export * from "./ElAktasBusena.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports